import { ENDPOINT_PATH_SEGMENTS, ENDPOINTS } from "../types";

export const useTct = (close?: () => void) => {
    const redirectToTct = (endpoint: string) => {
        const params = new URLSearchParams({
            endpoint: `${ENDPOINTS.Files}${endpoint}`,
            baseUrl: import.meta.env.VITE_BASE_URL,
            csrfCookieName: import.meta.env.VITE_CSRF_COOKIE_NAME
        });

        window.open(
            `/tct-loader.html?${params.toString()}`,
            "_blank",
            "noopener"
        );

        close?.();
    };

    const createConfigurationOnline = () =>
        redirectToTct(ENDPOINT_PATH_SEGMENTS.Create);

    const editConfigurationOnline = (fileId: number) =>
        redirectToTct(`${ENDPOINT_PATH_SEGMENTS.Edit}/${fileId}`);

    return { createConfigurationOnline, editConfigurationOnline };
};
